import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function FormJadwal({ isOpen, onClose, editData }) {
  const { token } = useAuth(); // ← pakai session token

  const [form, setForm] = useState({
    id_guru: "",
    id_mapel: "",
    id_kelas: "",
    hari: "",
    jam_mulai: "",
    jam_selesai: "",
  });

  const [guru, setGuru] = useState([]);
  const [mapel, setMapel] = useState([]);
  const [kelas, setKelas] = useState([]);

  const [openKelas, setOpenKelas] = useState(false);

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    if (!isOpen) return;

    axios
      .get("https://backend.smpn1kamal.sch.id/api/data-guru", { headers })
      .then((res) => setGuru(res.data))
      .catch(() => toast.error("Gagal ambil guru"));

    axios
      .get("https://backend.smpn1kamal.sch.id/api/datamapel", { headers })
      .then((res) => setMapel(res.data))
      .catch(() => toast.error("Gagal ambil mapel"));

    axios
      .get("https://backend.smpn1kamal.sch.id/api/kelas", { headers })
      .then((res) => setKelas(res.data))
      .catch(() => toast.error("Gagal ambil kelas"));
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    if (editData) {
      setForm({
        id_guru: String(editData.id_guru ?? ""),
        id_mapel: String(editData.id_mapel ?? ""),
        id_kelas: String(editData.id_kelas ?? ""),
        hari: editData.hari ?? "",
        jam_mulai: editData.jam_mulai ?? "",
        jam_selesai: editData.jam_selesai ?? "",
      });
    } else {
      setForm({
        id_guru: "",
        id_mapel: "",
        id_kelas: "",
        hari: "",
        jam_mulai: "",
        jam_selesai: "",
      });
    }
  }, [isOpen, editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        id_guru: Number(form.id_guru),
        id_mapel: Number(form.id_mapel),
        id_kelas: Number(form.id_kelas),
        hari: form.hari,
        jam_mulai: form.jam_mulai,
        jam_selesai: form.jam_selesai,
      };

      if (editData) {
        await axios.put(
          `https://backend.smpn1kamal.sch.id/api/jadwal/${editData.id_jadwal}`,
          payload,
          { headers }
        );
        toast.success("Jadwal diupdate");
      } else {
        await axios.post(
          "https://backend.smpn1kamal.sch.id/api/jadwal",
          payload,
          { headers }
        );
        toast.success("Jadwal ditambahkan");
      }

      onClose();
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Gagal menyimpan jadwal"
      );
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3 overflow-y-auto">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg border border-slate-100 overflow-visible">

        {/* HEADER */}
        <div className="border-b px-5 py-3 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-slate-700">
            {editData ? "Edit Jadwal" : "Tambah Jadwal"}
          </h2>

          <button
            onClick={onClose}
            className="text-slate-500 hover:text-red-500 text-xl font-bold"
          >
            ×
          </button>
        </div>

        {/* BODY */}
        <form
          onSubmit={handleSubmit}
          className="p-5 space-y-3 overflow-visible"
        >

          {/* GURU */}
          <select
            required
            value={form.id_guru}
            onChange={(e) =>
              setForm({ ...form, id_guru: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Pilih Guru</option>
            {guru.map((g) => (
              <option key={g.id_guru} value={g.id_guru}>
                {g.nama_lengkap}
              </option>
            ))}
          </select>

          {/* MAPEL */}
          <div className="relative z-[9999]">
            <select
              required
              value={form.id_mapel}
              onChange={(e) =>
                setForm({ ...form, id_mapel: e.target.value })
              }
              size={1}
              className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 bg-white"
            >
              <option value="">Pilih Mapel</option>
              {mapel.map((m) => (
                <option key={m.id_mapel} value={m.id_mapel}>
                  {m.nama_mapel}
                </option>
              ))}
            </select>
          </div>

          {/* CUSTOM DROPDOWN KELAS */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setOpenKelas(!openKelas)}
              className="w-full border rounded-lg px-3 py-2 text-sm text-left focus:ring-2 focus:ring-blue-500"
            >
              {form.id_kelas
                ? kelas.find((k) => k.id_kelas == form.id_kelas)?.nama_kelas
                : "Pilih Kelas"}
            </button>

            {openKelas && (
              <div className="absolute top-full left-0 z-50 mt-1 w-full bg-white border rounded-lg shadow max-h-40 overflow-y-auto">
                {kelas.map((k) => (
                  <div
                    key={k.id_kelas}
                    onClick={() => {
                      setForm({ ...form, id_kelas: k.id_kelas });
                      setOpenKelas(false);
                    }}
                    className="px-3 py-2 hover:bg-blue-100 cursor-pointer"
                  >
                    {k.nama_kelas}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* HARI */}
          <select
            required
            value={form.hari}
            onChange={(e) =>
              setForm({ ...form, hari: e.target.value })
            }
            className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Pilih Hari</option>
            {["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"].map(
              (h) => (
                <option key={h} value={h}>
                  {h}
                </option>
              )
            )}
          </select>

          {/* JAM */}
          <div className="grid grid-cols-2 gap-2">
            <input
              type="time"
              required
              value={form.jam_mulai}
              onChange={(e) =>
                setForm({ ...form, jam_mulai: e.target.value })
              }
              className="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />

            <input
              type="time"
              required
              value={form.jam_selesai}
              onChange={(e) =>
                setForm({ ...form, jam_selesai: e.target.value })
              }
              className="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* FOOTER */}
          <div className="flex justify-end gap-2 pt-3">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1.5 text-sm rounded-lg border hover:bg-slate-50"
            >
              Batal
            </button>

            <button
              type="submit"
              className="px-4 py-1.5 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700"
            >
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}